import axios from 'axios';
import { env } from 'env';
import { ICustomStyles } from '../interfaces';

export default class WorldsService {
  static getCustomStyles(
    domainName: string,
  ): Promise<{ customStyles: ICustomStyles | null }> {
    return axios
      .get(`${env.REACT_APP_API_URL}api/v2/worlds/styles`, {
        params: { domainName },
      })
      .then((res: any) => res.data);
  }
}
